<script>
import countlyVue from '../../compat/vue-core';
import FormCommons from './commons';

export default countlyVue.components.BaseComponent.extend({
  mixins: [FormCommons.BaseFormField],
  props: {
    subheading: { required: false },
    label: { required: false },
    optional: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    labelEnd: {
      type: Boolean,
      default: false,
    },
    fieldEnd: {
      type: Boolean,
      default: false,
    },
    isSubmit: {
      type: Boolean,
      default: false,
    },
    hideField: {
      type: Boolean,
      default: false,
    },
    disableFormWrapping: {
      type: Boolean,
      default: false,
    },
    orientation: {
      type: String,
      default: 'h',
    },
    tooltip: { type: String, default: null },
    hideValidationError: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    wrapperElement() {
      if (this.disableFormWrapping) {
        return 'div';
      }
      return 'form';
    },
    topClasses() {
      return { 'flex-col': this.orientation === 'v', 'cly-vue-form-field-n--narrow': this.narrow };
    },
    fieldClasses() {
      return {
        'w-full mt-4': this.orientation === 'v',
        'w-1/2 ml-4': this.orientation !== 'v',
        'items-end': this.fieldEnd,
        'mt-2': this.isSubmit,
      };
    },
    labelClasses() {
      return {
        'w-full': this.orientation === 'v',
        'w-1/2': this.orientation !== 'v',
        'items-end': this.labelEnd,
      };
    },
  },
});
</script>
<template>
  <div
    class="cly-vue-form-field-n flex w-full"
    :class="topClasses"
  >
    <div
      class="flex flex-col justify-center"
      :class="labelClasses"
    >
      <div
        v-if="label"
        class="flex items-baseline"
      >
        <span :class="[narrow ? 'text-sm':'text-md', 'font-medium']">
          {{ label }}
          <cly-tooltip-icon
            v-if="tooltip"
            class="bu-is-flex-grow-1 bu-ml-2"
            :tooltip="tooltip"
          />
        </span>
      </div>
      <div
        v-if="subheading"
        class="text-xs mt-1"
      >
        {{ subheading }}
      </div>
      <div
        v-show="optional"
        class="text-xs text-heading color-cool-gray-40"
      >
        {{ $t("common.optional") }}
      </div>
    </div>
    <div
      v-show="!hideField"
      class="flex flex-col"
      :class="fieldClasses"
    >
      <component
        :is="wrapperElement"
        @submit.prevent
      >
        <validation-provider
          v-if="rules"
          v-slot="validation"
          :rules="rules + '|noHtml'"
          :bails="bails"
          v-bind="$attrs"
          v-on="$listeners"
        >
          <div
            class="cly-vue-form-field__inner el-form-item flex flex-row"
            :class="{'is-error': validation.errors.length > 0}"
          >
            <slot
              v-bind="validation"
              :rule-status="ruleStatus(validation)"
            />
            <img
              v-if="validation.errors.length"
              v-tooltip="$t(`mycountly.validations.${Object.keys(validation.failedRules)[0]}`)"
              class="text-warning text-sm flex items-center"
              src="@/assets/images/warning-icon.svg"
              alt="warning-icon"
            >
          </div>
        </validation-provider>
        <div
          v-else
          class="cly-vue-form-field__inner el-form-item flex flex-row"
        >
          <slot />
        </div>
      </component>
    </div>
  </div>
</template>
<style lang="scss">
  .cly-vue-form-field-n + .cly-vue-form-field-n {
    margin-top: 24px;
  }
  .cly-vue-form-field-n + .cly-vue-form-field-n--narrow {
    margin-top: 8px;
  }
  .cly-vue-form-field-n input.el-input__inner {
    max-width: 300px!important;
    height: 40px!important;
}
</style>
